export const ROUTES = {
  // outer app-level routes
  ROOT: "/",
  LOGIN: "/login",

  // dashboard inner routes (DashboardLayout) 
  DASHBOARD_TABLE: "table",
  DASHBOARD_FACULTY_MANAGEMENT: "faculty-management",
  DASHBOARD_LOGIN_FORM: "login-form",
  DASHBOARD_COURSE_MANAGEMENT: "course-management",
  DASHBOARD_BATCH_MANAGEMENT: "batch-management",
  DASHBOARD_ATTENDANCE_MANAGEMENT: "attendance-management",
  DASHBOARD_ALL_STUDENTS: "all-students",
  DASHBOARD_EXTERNAL_ADMISSIONS: "external-admissions",
  DASHBOARD_ENROLLMENT_MANAGEMENT: "enrollment-management",
  DASHBOARD_FEES_MANAGEMENT: "fees-management",
  DASHBOARD_OFFER_MANAGEMENT: "offer-management",
  DASHBOARD_COURSE_CONTENT_MANAGEMENT: "course-content-management",
  DASHBOARD_STUDENT_MANAGEMENT: "student-management",
  DASHBOARD_SUBSCRIPTION_MANAGEMENT: "subscription-management",
  DASHBOARD_WEBINAR_MANAGEMENT: "events-management",
  DASHBOARD_WEBINAR_REGISTRATIONS: "eventa-registrations",
  DASHBOARD_LECTURE_MANAGEMENT: "lecture-management",
  DASHBOARD_REVIEWS_MANAGEMENT: "reviews-management",
  DASHBOARD_BLOG_MANAGEMENT: "blog-management",
  DASHBOARD_DEMO_VIDEO_MANAGEMENT: "demo-video-management",
  DASHBOARD_PLACEMENT_MANAGEMENT: "placement-management",
  DASHBOARD_PREBOOKING_PAYMENT: "prebooking-payment",
  DASHBOARD_VIDEO_REVIEW_MANAGEMENT: "video-review-management",
  DASHBOARD_ENQUIRY_MANAGEMENT: "enquiry-management",
  DASHBOARD_JOB_MANAGEMENT: "job-management",
  DASHBOARD_HIRE_FROM_US: "hire-from-us-management",
  DASHBOARD_FAQ_MANAGEMENT: "faq-management",
  DASHBOARD_CHATBOT_QUERIES: "chatbot-queries",
};